import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';

import { ModalDeliveryShareService } from '../modal-delivery-share.service';
import * as fromActions from './modal-delivery-share.actions';

@Injectable()
export class ModalDeliveryShareEffects {
  actions$ = inject(Actions);
  modalDeliveryShareService = inject(ModalDeliveryShareService);

  loadSharedReasons$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.loadSharedReason),
    switchMap(() => this.modalDeliveryShareService.getSharedReasons().pipe(
      map((reasons: any) => fromActions.loadSharedReasonSuccess({ reasons })),
      catchError(() => of(fromActions.loadSharedReasonError())),
    )),
  ));

  sendDelivery$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.sendDelivery),
    switchMap(({ deliveryShare }) => this.modalDeliveryShareService.sendDelivery(deliveryShare)
      .pipe(
        map(() => fromActions.sendDeliverySuccess()),
        catchError(() => of(fromActions.sendDeliveryError())),
      )),
  ));
}
